import { render } from "./SliderMainMobile.vue?vue&type=template&id=afda51ba&scoped=true"
import script from "./SliderMainMobile.vue?vue&type=script&lang=js"
export * from "./SliderMainMobile.vue?vue&type=script&lang=js"

import "./SliderMainMobile.vue?vue&type=style&index=0&id=afda51ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afda51ba"]])

export default __exports__